import { useQuery, UseQueryOptions } from 'react-query';

import { ApiError, ApiMethod, ApiRequest, ApiResponse } from 'services/api';
import { createQueryHookOptions } from './utils';
import { RestQueryHookResult } from './useRestQuery';

export type UseRestPostQueryQueryOptions<Response = any> = Omit<
  UseQueryOptions<Response | undefined, ApiError>,
  'queryKey' | 'queryFn'
>;

/**
 * Api POST Query Hook
 *
 * Wrapped REST query requests with some abstractions.
 * @param url Target Endpoint URL
 * @param params JSON body parameters to send in the request
 * @param queryOptions React-Query options
 * @param requestConfig API request config
 * @returns Response object
 */
export function useRestPostQuery<Response = any, Params = Record<string, unknown>>(
  url?: string,
  params?: Params,
  queryOptions?: UseRestPostQueryQueryOptions<Response>,
  requestConfig?: ApiRequest,
  handleResponse?: (response: ApiResponse<Response>) => Response,
): RestQueryHookResult<Response> {
  return useQuery(
    createQueryHookOptions({
      url,
      params,
      queryOptions,
      method: ApiMethod.post,
      requestConfig,
      handleResponse,
    }),
  );
}
